module.exports = __webpack_public_path__ + "static/winding-90481792357587803324d9d7626f380f.png";